<template>
  <div>
    <transition name="slide" mode="out-in">
      <div class="title" v-if="!alert" key="create">
        Create New Alert
      </div>
      <div class="title" v-else key="edit">
        <button class="btn" v-on:click="cancel">
          <img src="../assets/icons/back.svg" alt="Back" />
        </button>
        Edit Alert
      </div>
    </transition>
    <form class="form" v-on:submit.prevent="save">
      <div class="form-group row">
        <label for="headline" class="col-form-label col-md-3">Headline:</label>
        <div class="col-md-9">
          <input type="text" name="headline" id="headline" placeholder="Enter your headline" class="form-control" v-model="headline" />
        </div>
      </div>
      <div class="form-group row">
        <label for="startMonth" class="col-form-label col-md-3">Start date:</label>
        <div class="col-md-9">
          <div class="row less-gap">
            <div class="col-md-12 col-lg-4 mt-md-2 mt-lg-0">
              <select name="startMonth" id="startMonth" class="form-control" v-model="startMonth">
                <option value="">Month</option>
                <option v-for="month in months" :value="month" :key="month">{{ month }}</option>
              </select>
            </div>
            <div class="col-md-12 col-lg-4 mt-md-2 mt-lg-0">
              <select name="startDay" id="startDay" class="form-control" v-model="startDay">
                <option value="">Day</option>
                <option v-for="day in 31" :value="day" :key="day">{{ day }}</option>
              </select>
            </div>
            <div class="col-md-12 col-lg-4 mt-md-2 mt-lg-0">
              <select name="startYear" id="startYear" class="form-control" v-model="startYear">
                <option value="">Year</option>
                <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="endDate" class="col-form-label col-md-3">End Date:</label>
        <div class="col-md-9">
          <label class="check">
            <input type="checkbox" name="endDate" id="endDate" v-model="endDate" />
            <span></span>
          </label>
          <div class="row less-gap" v-if="endDate">
            <div class="col-md-12 col-lg-4 mt-md-2 mt-lg-0">
              <select name="endMonth" id="endMonth" class="form-control" v-model="endMonth">
                <option value="">Month</option>
                <option v-for="month in months" :value="month" :key="month">{{ month }}</option>
              </select>
            </div>
            <div class="col-md-12 col-lg-4 mt-md-2 mt-lg-0">
              <select name="endDay" id="endDay" class="form-control" v-model="endDay">
                <option value="">Day</option>
                <option v-for="day in 31" :value="day" :key="day">{{ day }}</option>
              </select>
            </div>
            <div class="col-md-12 col-lg-4 mt-md-2 mt-lg-0">
              <select name="endYear" id="endYear" class="form-control" v-model="endYear">
                <option value="">Year</option>
                <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="message" class="col-form-label col-md-3">Message:</label>
      </div>
      <div class="form-group row">
        <div class="col">
          <textarea name="message" id="message" placeholder="Enter your alert message" class="form-control" rows="4" v-model="message" v-on:change="limitMessage" />
          <span class="count">{{ message.length }} / {{ maxMessageChars }} Characters</span>
        </div>
      </div>
      <div class="form-group error" v-if="error">
        <p>{{ error }}</p>
      </div>
      <div class="form-group">
        <button type="submit" class="btn btn-red btn-block">
          <span class="spinner-border spinner-border-sm" role="status" v-if="isLoading"></span>
          <span v-else-if="alert">Update</span>
          <span v-else>Create</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
  name: "EditAlert",
  data: function () {
    return {
      months: moment.months(),
      years: [
        moment().year(),
        moment().add(1, 'years').year(),
      ],
      headline: "",
      startMonth: "",
      startDay: "",
      startYear: "",
      endDate: true,
      endMonth: "",
      endDay: "",
      endYear: "",
      message: "",
      maxMessageChars: 200,
      isLoading: false,
      error: "",
    };
  },
  props: [ 'alert', 'notify', 'cancel' ],
  watch: {
    alert: function(newVal) {
      if (newVal != null) {
        this.headline = this.alert.headline;
        this.message = this.alert.message;
        let alertStartDate = new Date(this.alert.startDate);
        this.startMonth = alertStartDate.toLocaleString('en-US', { month: 'long' });
        this.startDay = alertStartDate.toLocaleString('en-US', { day: 'numeric' });
        this.startYear = alertStartDate.toLocaleString('en-US', { year: 'numeric' });
        if (this.alert.endDate) {
          let alertEndDate = new Date(this.alert.endDate);
          this.endDate = true;
          this.endMonth = alertEndDate.toLocaleString('en-US', { month: 'long' });
          this.endDay = alertEndDate.toLocaleString('en-US', { day: 'numeric' });
          this.endYear = alertEndDate.toLocaleString('en-US', { year: 'numeric' });
        }
        else {
          this.endDate = false;
        }
      }
      else {
        this.headline = "";
        this.message = "";
        this.startMonth = "";
        this.startDay = "";
        this.startYear = "";
        this.endDate = true;
        this.endMonth = "";
        this.endDay = "";
        this.endYear = "";
      }
    }
  },
  methods: {
    save: function () {
      this.isLoading = false;
      this.error = "";

      if (!this.headline || !this.message || !this.startMonth || !this.startDay || !this.startYear) {
        this.error = "Please fill in all fields";
        return;
      }

      let reqData = new FormData();
      reqData.append('headline', this.headline);
      reqData.append('message', this.message);
      reqData.append('startDate', moment(`${this.startYear} ${this.startMonth} ${this.startDay}`, 'YYYY MMMM D'));

      if (this.endDate) {
        if (!this.endYear || !this.endMonth || !this.endDay) {
          this.error = "Please select an end month, day, and year, or disable the end date";
          return;
        }

        reqData.append('endDate', moment(`${this.endYear} ${this.endMonth} ${this.endDay}`, 'YYYY MMMM D'));
      }

      let reqUrl = "/api/alerts/save";
      if (this.alert && this.alert.id) {
        reqUrl = `/api/alerts/${this.alert.id}/save`;
      }

      this.isLoading = true;

      axios.post(reqUrl, reqData)
        .then((response) => {
          this.isLoading = false;
          this.headline = "";
          this.message = "";
          this.startYear = "";
          this.startMonth = "";
          this.startDay = "";
          this.endDate = true;
          this.endYear = "";
          this.endMonth = "";
          this.endDay = "";
          this.notify(response.data.alert, !(this.alert && this.alert.id));
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            let errorStr = "";
            if (error.response.data.error) {
              errorStr = error.response.data.error;
            }
            else if (error.response.data.errors) {
              errorStr = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
            }
            else {
              errorStr = error.response.data.message;
            }

            this.error = errorStr;
          }
          else {
            this.error = "Sorry, something went wrong. Please try again later."
          }
        });
    },
    limitMessage: function () {
      if (this.message.length > this.maxMessageChars) {
        this.message = this.message.slice(0, this.maxMessageChars);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

div.title {
  color: #4A4A4A;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.2;
  margin: 51px 0 36px;
  position: relative;

  button {
    position: absolute;
    right: 100%;
    padding: 0 10px;
  }
}

div.less-gap.row {
  margin-left: -5px;
  margin-right: -5px;

  > div {
    padding-left: 5px;
    padding-right: 5px;
  }
}

label.col-form-label[for="endDate"] {
  align-items: flex-start;
  padding-top: 1em;
}

span.count {
  display: block;
  font-size: 0.875rem;
  color: rgba(#4A4A4A, 0.55);
  margin: 1em 0;
}

.slide-enter-active, .slide-leave-active {
  transition: transform 250ms, opacity 250ms;
}
.slide-enter, .slide-leave-to /* .slide-leave-active below version 2.1.8 */ {
  transform: translateY(25px);
  opacity: 0;
}
</style>
